<div class="card card-custom custom-table gutter-b">

    <div class="card-header border-0 flex-column">
        <div class="d-flex justify-content-between flex-wrap">
            <!--Card Title-->
            <div class="card-title">
                <h1 class="card-label m-0">Feedback List</h1>
            </div>
        </div>
    </div>

    <div class='card-body'>

        <!--Table Data Filters-->
        <div id="filtersRow" class="filter-row row">
            <div class="table-selection col-12 col-sm-5 col-md-3 col-xl-2"></div>
            <div class="table-search
                        col-12 col-sm-5 col-md-3 col-xl-3
                        ml-sm-auto">
                <label>Search</label>
                <input id="tableSearchBox">
                <span class="fas fa-search"></span>
            </div>
        </div>

        <table id="myTable" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"
               class="table nowrap compact hover order-column">
            <thead>
            <tr>
                <th>Nr.</th>
                <th>Subject</th>
                <th>Date</th>
                <th>Link</th>
                <th>User</th>
                <th>Actions</th>
                <th></th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let item of feedbackList; let i = index">
                <!--Nr.-->
                <td>{{i + 1}}</td>
                <!--Subject.-->
                <td class="cell-hover" routerLink="/feedback/{{item.id}}">
                    {{item.subject}}
                </td>
                <!--Date.-->
                <td>{{item.date + 'z'| date : 'dd-MM-yyyy hh:mm a'}}</td>
                <!--Link.-->
                <td>{{item.linkURL}}</td>
                <!--User.-->
                <td>{{item.userName}}</td>
                <!--Actions-->
                <td>
                    <div class='d-flex justify-content-end'>
                        <button type="button" class="btn-list btn-main mr-2"
                                placement="bottom" ngbTooltip="View Feedback"
                                routerLink="/feedback/{{item.id}}"
                                *ngIf="userRole | roleChecker : ['ROLE_super_admin','ROLE_admin']">
                            <span class="far fa-eye"></span>
                        </button>
                    </div>
                </td>
                <td>
                    <!--empty table data-->
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</div>
